import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Client } from 'src/app/core/auth/models/client.model';
import { UploadProfileImage } from 'src/app/models/profile-upload-image-request.model';
import { environment } from 'src/environments/environment';
import { ProfileImage } from '../../models/profile-image.model';
import { BaseService } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService extends BaseService<ProfileImage> {
  constructor(protected http: HttpClient) {
    super(http, 'users/profile-image');
  }

  getAllClients(): Observable<HttpResponse<{ data: Client[] }>> {
    return this.http.get<{ data: Client[] }>(
      `${environment.baseUrl}/users/authorizations`,
      { observe: 'response' }
    );
  }

  profileImageUpload(body: UploadProfileImage): Observable<HttpResponse<null>> {
    return this.http.post<null>(
      `${environment.baseUrl}/users/profile-image`,
      body,
      { observe: 'response' }
    );
  }
}
